import {FC, ReactNode} from "react";

type Props = {
    children: ReactNode;
    title: string;
    className?: string;
}

export const AdminPageCard:FC<Props> = ({children, title, className}) => {
    return (
        <div className={`mx-auto p-8 bg-white shadow-md rounded-md mt-5 mb-5 ${className}`}>
            <h2 className="text-2xl font-bold mb-6">{title}</h2>
            {children}
        </div>
    );
};